import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { TERMS_AND_CONDITION } from "../../../../services/ApiCalls";

const TermsCondition = () => {
 


  const [pageContent, setPageContent] = useState("");

  const getData = async (url) => {
    try {
      const response = await TERMS_AND_CONDITION();

      const parser = new DOMParser();
      const doc = parser.parseFromString(response.data, "text/html");
      const bodyContent = doc.body.innerHTML;
      setPageContent(bodyContent);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <section className="termsCondition py-2">
        <Container>
          <Row>
            {/* <Col lg="12" className="my-2">
              <div className="sectionHeader">
                <h3 className="m-0 fw-sbold themeBlue">Terms and Condition</h3>
              </div>
            </Col> */}
            <Col lg="12" className="my-2">
            <div className="py-5 px-4 bg-white">
          <div dangerouslySetInnerHTML={{ __html: pageContent }} />
        </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default TermsCondition;
